import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    agreementCheckbox: {
      description:
        'Once this mandate is confirmed, the debtor can make direct debits from your account without the possibility of contesting them with Shine.',
      descriptionWithBankAccountName:
        'Once this mandate is confirmed, the debtor can make direct debits from your account **{bankAccountName}** without the possibility of contesting them with Shine.',
      title: 'Yes, I want to add this mandate',
    },
    ctaAllGood: 'All good! Continue',
    errorToast: {
      message:
        'Please try again in a few minutes and don’t hesitate to contact us if the error remains',
      title: 'An error occurred',
    },
    recapItems: {
      creditorIdentifier: 'SEPA Creditor Identifier (SCI)',
      creditorName: 'Creditor Name',
      label: 'Custom label',
      uniqueMandateReference: 'Unique Mandate Reference (UMR)',
    },
    title: 'Confirm your new B2B mandate',
  },
  fr: {
    agreementCheckbox: {
      description:
        'Une fois ce mandat confirmé, le débiteur pourra réaliser des prélèvements sur votre compte sans possibilité de contestation auprès de Shine.',
      descriptionWithBankAccountName:
        'Une fois ce mandat confirmé, le débiteur pourra réaliser des prélèvements sur votre compte **{bankAccountName}** sans possibilité de contestation auprès de Shine.',
      title: 'Je confirme l’ajout de ce mandat',
    },
    ctaAllGood: 'C’est tout bon\xA0!',
    errorToast: {
      message:
        'Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste',
      title: 'Une erreur est survenue',
    },
    recapItems: {
      creditorIdentifier: 'Identifiant Créancier SEPA (ICS)',
      creditorName: 'Nom du créancier',
      label: 'Libellé personnalisé',
      uniqueMandateReference: 'Référence Unique de Mandat (RUM)',
    },
    title: 'Confirmez votre nouveau mandat B2B',
  },
});

export default locales;
